import BaseApiService from './api.base.service'
export default class TokensApiService extends BaseApiService {
  constructor() {
    super('Autenticazione')
  }

  getTokenByTsId(userId, tsId) {
    const customService = window.createApiService(false, false)

    return customService({
      url: this.composeUrl(this.url, '/login?isTSIdUser=true'),
      method: 'post',
      headers: { Authorization: 'Basic ' + btoa(userId + ':' + tsId) },
    })
  }

  getTokenByFiscalCode(fiscalCode, password) {
    const customService = window.createApiService(false, false)
    return customService({
      url: this.composeUrl(this.url, '/login'),
      method: 'post',
      headers: { Authorization: 'Basic ' + btoa(fiscalCode + ':' + password) },
    })
  }
}

export const tokensApi = new TokensApiService()
